// extracted by mini-css-extract-plugin
export default {"wrapper":"G07ea91","item-0":"G82c172","item-1":"G243dda"};